import React from 'react'
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/home3/block2.png";
import coreImg1 from "../assets/img/ProductsDetails/AboutCommercialCastorOil.jpg";
import PageBanner from "../Components/PageBanner";
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';

const CommercialOils = () => {
  return (
    <>
         <PageBanner title='Commercial Castor Oil  ' bannerBg={bannerBg} currentPage='  Commercial Castor Oil' />
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" />
              </div>
            </div>
            <div className="col-xl-6 ps-xl-5 col-lg-6 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About Commercial Castor Oil </h2>
                <p>
                Commercial-grade castor oil, also referred to as industrial-grade castor oil, is one of the most widely used forms of castor oil in various industrial applications. 
                </p>
                <br></br>
                <div className="checked-features-list style-2">
                <ul>
                <h6>Key Characteristics:</h6>
                  <li>Extracted from the seeds of Ricinus Communis. </li>
                  <li>Pale yellow, viscous, and oily liquid. </li>
                  <li>Insoluble in water. </li>
                  <li>Contains over 87% ricinoleic acid, a unique hydroxy fatty acid. </li>
                </ul>
              </div>
                <div className="checked-features-list style-2 pt-4">
                <ul>
                <h6>  Applications:</h6>
                  <li>Serves as the primary raw material for producing different grades of castor oil and its derivatives. </li>
                  <li>Utilized as an ingredient in pharmaceutical and cosmetic formulations.  </li>
                  <li>Acts as a key base material for manufacturing specialized castor oil derivatives.  </li>
                  
                </ul>
              </div>
              </div>
              {/* <div className="checked-features-list style-2">
                <ul>
                  <li>Brand Identity</li>
                  <li>Website Design &amp; Development</li>
                  <li>SEO &amp; Analytics</li>
                </ul>
              </div> */}
              {/* <Link to="/about" className="theme-btn style-3 mt-30">
                click here
              </Link> */}
            </div>
          </div>
          {/* <div className="row align-items-center section-padding pb-0">
            <div className="col-xl-6 col-lg-6 col-12 mt-5 mt-lg-0 order-2 order-lg-1">
              <div className="section-title-3">
              
                <h2>Our Strength in Cotton </h2>
                <p>
                  Leveraging strong industry relationships and a significant
                  domestic presence in key cotton-producing markets, our Cotton
                  Platform has steadily expanded its operations, earning a
                  trusted reputation among suppliers and customers.
                </p>
                <br></br>
                <p>
                  We are a leading force in South India’s domestic cotton trade,
                  ensuring seamless supply chain operations. Our Group has
                  established an advanced research division, utilizing
                  cutting-edge technology to analyze critical factors such as
                  consumption patterns, weather conditions, economic trends,
                  political developments, and macroeconomic indicators.
                </p>
                <br></br>
                <p>
                  Our expertise in monitoring and managing supply and demand
                  dynamics gives us a competitive edge. Operating around the
                  clock, we stay ahead of market trends and provide reliable,
                  timely deliveries to spinning mills worldwide. Our success is
                  built on strategic alliances with producers and cooperative
                  organizations.
                </p>
              </div>
              <div className="checked-features-list style-2">
                <h6>Cotton Varieties We Offer </h6>
                <div className="row">
                  <div className="col-6">
                    <ul>
                      <li>HANKAR-6</li>
                      <li>V-797 </li>
                      <li>MECH-1 </li>
                    </ul>
                  </div>
                  <div className="col-6">
                    <ul>
                      <li>MCU-5 </li>
                      <li>DCH-32 </li>
                      <li>Imported Cotton </li>
                    </ul>
                  </div>
                </div>
              </div>
              <Link to="/contact" className="theme-btn style-3 mt-30">
                Contact Us
              </Link>
            </div>
            <div className="col-xl-6 col-lg-6 ps-xl-5 col-12 order-1 order-lg-2">
              <div className="content-block-img">
                <img src={coreImg2} alt="" />
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  )
}

export default CommercialOils
